const administrator = {
	tabs: {
		manage_permissions: "Berechtigungen verwalten",
		user_activate: "Konto aktivieren",
		user_create_new: "Neuen Benutzer hinzufügen",
		user_management: "Verwalten von Benutzern",
	},
	title: "Administrator",

	/* -------------------------------------------------------------------------- */
	/*                               USER MANAGEMENT                              */
	/* -------------------------------------------------------------------------- */
	user_management: {
		/* -------------------------------- ACTIVATE -------------------------------- */
		activate: {
			description:
				"Geben Sie unten das Passwort ein, das Sie für Ihr neues Konto verwenden möchten.",
			title: "Kontoaktivierung für ",
		},

		/* --------------------------------- ACTIVE --------------------------------- */
		active: {
			block_modal: {
				description: "Sind Sie sicher, dass Sie <strong>{{username}}</strong> blockieren möchten?",
				status: {
					success: "Benutzer <strong>{{username}}</strong> wurde erfolgreich blockiert!",
					unknown:
						"Benutzer <strong>{{username}}</strong> kann derzeit nicht blockiert werden. Versuchen Sie es erneut oder kontaktieren Sie unsere Support-Abteilung.",
				},
				title: "Benutzer blockieren",
			},

			// BUTTONS
			button_add_user: "Benutzer hinzufügen",
			deblock_modal: {
				description:
					"Sind Sie sicher, dass Sie <strong>{{username}}</strong> freischalten möchten?",
				status: {
					success: "Benutzer <strong>{{username}}</strong> wurde erfolgreich freigeschaltet!",
					unknown:
						"Benutzer <strong>{{username}}</strong> kann derzeit nicht freigeschaltet werden. Versuchen Sie es erneut oder kontaktieren Sie unsere Support-Abteilung.",
				},
				title: "Benutzer freischalten",
			},

			// MODALS
			delete_modal: {
				description: "Sind Sie sicher, dass Sie <strong>{{username}}</strong> löschen wollen?",
				status: {
					success: "Benutzer <strong>{{username}}</strong> wurde erfolgreich gelöscht!",
					unknown:
						"Der Benutzer <strong>{{username}}</strong> kann zur Zeit nicht gelöscht werden. Bitte versuchen Sie es erneut oder wenden Sie sich an unsere Support-Abteilung.",
				},
				title: "Benutzer löschen",
			},
			description:
				"Hier befinden sich die im Portal angemeldeten Benutzer. Hier können Benutzer hinzugefügt, geändert und gelöscht werden.",
			title: "Aktive Benutzer",
		},
		add_user_first: {
			description:
				"Verwenden Sie danach nur noch dieses neue Konto, um sich anzumelden. Erstellen Sie dann über Ihr neues Konto Konten für alle Kollegen und geben Sie ihnen die entsprechenden Berechtigungen.",
			title:
				"Sie können diese Seite derzeit nicht verlassen. Sie müssen zuerst ein persönliches Konto (Benutzer) anlegen.",
		},

		categories: {
			action: {
				update: "Labels aktualisieren",
			},
			description:
				"Wählen Sie hier die Label(s) aus, die Sie einem Benutzer zuweisen möchten. Die Labels dienen lediglich der Übersicht und werden verwendet, um die Rolle oder Aufgabe zu kennzeichnen, die ein Benutzer in Ihrem Unternehmen ausübt.",
			placeholder: "Label(s) auswählen",
			status: { success: "Labels wurden erfolgreich mit dem Benutzer verknüpft" },
			title: "Labels auswählen",
		},
		/* --------------------------------- CREATE --------------------------------- */
		create: {
			sign_in_details: {
				description:
					"Geben Sie hier die E-Mail-Adresse und den Benutzernamen für den neuen Benutzer ein.",
				title: "Anmeldedaten eingeben",
			},
			status: {
				email_address_invalid:
					"Die von Ihnen eingegebene E-Mail-Adresse ist falsch. Bitte verwenden Sie eine gültige E-Mail-Adresse.",
				invalid:
					"Ihre Anfrage zum Hinzufügen eines neuen Benutzers wurde abgelehnt. Bitte versuchen Sie es erneut oder wenden Sie sich an unsere Support-Abteilung.",
				success:
					"Der neue Benutzer wurde erfolgreich hinzugefügt. Es wurde eine Einladung an die folgende E-Mail-Adresse gesendet:",
				unknown:
					"Beim Hinzufügen eines neuen Benutzers ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder wenden Sie sich an unsere Support-Abteilung.",
				username_in_use: "Der von Ihnen eingegebene Benutzername ist bereits in Gebrauch.",
			},
			user_details: {
				description:
					"Geben Sie hier die Kontodaten für den neuen Benutzer ein. Der Benutzer kann diese nach der Registrierung bearbeiten.",
				title: "Kontodaten eingeben",
			},
		},

		/* --------------------------------- INVITE --------------------------------- */
		invite: {
			button: "Benutzer schnell hinzufügen",
			description:
				"Hier finden Sie die bekannten Kontakte, die gefunden wurden, aber noch kein Portal-Konto haben. Sie können ganz einfach ein Konto für sie erstellen, indem Sie auf die Schaltfläche „Schnell erstellen“ klicken.",
			empty_table: "Es wurden keine Kontakte gefunden.",
			title: "Bekannte Kontakte ohne Portal-Konto",
		},

		/* --------------------------------- PENDING -------------------------------- */
		pending: {
			// MODALS
			delete_modal: {
				description:
					"Sind Sie sicher, dass Sie die Einladung für den Benutzer <strong>{{{username}}</strong> widerrufen möchten?",
				status: {
					success: "Einladung für Benutzer <strong>{{username}}</strong> erfolgreich abgebrochen!",
					unknown:
						"Die Einladung des Benutzers <strong>{{username}}</strong> kann zur Zeit nicht widerrufen werden. Bitte versuchen Sie es erneut oder kontaktieren Sie unsere Support-Abteilung.",
				},
				title: "Einladung widerrufen",
			},
			description:
				"Hier befinden sich die Benutzer, die eingeladen wurden, aber die Einladung noch nicht angenommen haben. In diesem Abschnitt können Einladungen storniert und erneut gesendet werden.",
			empty_table: "Es wurden offene Einladungen gefunden.",
			resend_modal: {
				description:
					"Sind Sie sicher, dass Sie dem Benutzer <strong>{{username}}</strong> eine neue Einladung schicken wollen?",
				status: {
					success: "Einladung erfolgreich an <strong>{{username}}</strong> erneut gesendet!",
					unknown:
						"Eine neue Einladung kann derzeit nicht an den Benutzer <strong>{{username}}</strong> gesendet werden. Bitte versuchen Sie es erneut oder wenden Sie sich an unsere Support-Abteilung.",
				},
				title: "Einladung erneut senden",
			},
			title: "Benutzer warten auf Aktivierung",
		},

		/* ------------------------------- PERMISSIONS ------------------------------ */
		permissions: {
			assign: {
				active:
					"Die Änderung der Benutzerrechte gilt für den Benutzer <strong>{{username}}</strong>.",
				"allow-all": "Alles erlauben",
				description:
					"In diesem Abschnitt können Rechte für den Benutzer zugewiesen werden. Die Rechte sind nach Kategorien gruppiert, jede Kategorie kann durch Anklicken aufgeklappt werden.",
				title: "Dem Benutzer Rechte zuweisen.",
			},
			categories: {
				admin: "Administratorrechte",
				company: "Unternehmensrechte",
			},

			clone: {
				description:
					"Indem Sie die Benutzerrechte eines anderen Unterbenutzers kopieren, können Sie dem neuen Benutzer einfach Berechtigungen zuweisen.",
				placeholder: "Benutzerrechte kopieren",
				title: "Benutzerrechte kopieren",
			},
			description: "Hier können Sie die Rechte des Benutzers verwalten.",
			permission_titles: {
				admin: {
					user_create: "Benutzer erstellen",
					user_delete: "Benutzer löschen",
					user_read: "Benutzer anzeigen",
					user_update: "Benutzer bearbeiten",
				},
				company: {
					billing_invoices_read: "Rechnungen anzeigen",
					billing_orders_read: "Bestellungen anzeigen",
					details_read: "Details anzeigen",
					details_update: "Details bearbeiten",
				},
			},
			title: "Verwalten von Benutzerrechten",
		},

		update: {
			success: "Die Berechtigungen wurden erfolgreich aktualisiert.",
		},
	},
};

export default administrator;
